import { httpSingleton } from '@/lib/http-client';
import { AiProject } from '@/lib/models';

export const aiProjectService = {
	getProjects() {
		return httpSingleton.orchestrateRequest<{ aiProjects: AiProject[] }>({
			method: 'GET',
			url: '/advisory-service/api/v1/ai-projects',
		});
	},
	createProject(data: { title: string }) {
		return httpSingleton.orchestrateRequest<{ aiProject: AiProject }>({
			method: 'POST',
			url: '/advisory-service/api/v1/ai-project',
			data,
		});
	},
	updateProject(aiProjectId: string, data: { title: string }) {
		return httpSingleton.orchestrateRequest<{ aiProject: AiProject }>({
			method: 'PUT',
			url: `/advisory-service/api/v1/ai-project/${aiProjectId}`,
			data,
		});
	},
	deleteProject(aiProjectId: string) {
		return httpSingleton.orchestrateRequest<void>({
			method: 'DELETE',
			url: `/advisory-service/api/v1/ai-project/${aiProjectId}`,
		});
	},
	addConversationToProject(aiProjectId: string, data: { aiConversationId: string }) {
		return httpSingleton.orchestrateRequest<{ aiProject: AiProject }>({
			method: 'PUT',
			url: `/advisory-service/api/v1/ai-project/${aiProjectId}/conversation`,
			data,
		});
	},
	removeConversationFromProject(aiProjectId: string, data: { aiConversationId: string }) {
		return httpSingleton.orchestrateRequest<{ aiProject: AiProject }>({
			method: 'DELETE',
			url: `/advisory-service/api/v1/ai-project/${aiProjectId}/conversation`,
			data,
		});
	},
};
